export default __webpack_public_path__ + "static/media/Set's Perversion.68ea5f05.jpg";